export default "__VITE_ASSET__BgpGOFWl__"